var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"club-dashboard"},[_c('dashboard-charts',{attrs:{"setLoading":_vm.setLoading}}),_c('LoadingOverlay',{attrs:{"loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }